module.exports = __webpack_public_path__ + "img/default.28e9edde.svg";